<template>
    <v-container grid-list-lg>
        <v-layout row wrap style="padding-bottom:20px"> 
               <v-loading class="loading" v-model="loading" v-if="loading">
    
                    <v-progress-circular persistent
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
            
                </v-loading>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Conversas</v-toolbar-title>
                    <v-btn flat @click="dialogNewUsers = true" outline color="white"  style="position:absolute; right:20px; top:7px">Novo</v-btn>
                </v-toolbar>

                <!--v-flex v-for="i in 10" :key="`4${i}`" xs12 sm8 md4-->
                <!--v-flex v-for="(fotografo, idx) in 10" :key="idx" xs12 sm8 md4-->
                <v-flex v-for="(item, index) in itemsMensagens" xs12 sm6 md4 row style="margin-bottom:5px; padding:1px">
                    
                    <v-card>
                    
                        <v-card-text>
                            <v-btn class="deletar" flat color="orange" flat="flat" @click="deletarItem(item.slug)">x</v-btn>
                            <v-card-title primary-title :data-slug="item.slugOutraPessoa">
                                <!--div class="imagem"  style="background-image: url('http://www.closebecoming.co.uk/images/category_10/Honey%20%20B%20Women%20Black%20Self%20Design%20Top%20Beautiful%20BLOVOT.jpg');" ></div-->
                                <div @click="goToMessage(item.slugOutraPessoa)" class="imagem" v-bind:style="{ 'background-image': 'url(' + item.imagem + ')' }" ></div>
                                <div @click="goToMessage(item.slugOutraPessoa)" style="width:65%" class="body-content">
                                    
                                    <h3 class="headline mb-0" >{{item.nomeChat}}</h3> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                    <div style="visibility:hidden" :title="item.customtimestamp">{{item.customtimestamp}}</div><br />
                                    
                                </div>
                            </v-card-title>  

                            <!--v-card-actions>
                                <div class="instagram" style="height:20px;"><a :href="item.instagram" target="_blank" v-if="item.instagram != ''"><img width="20px" src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/599px-Instagram_icon.png"></a></div>
                                <v-btn class="editar" flat color="orange" flat="flat" @click="editarItem(item.slug)">Editar</v-btn>
                                <v-btn class="release" flat color="orange" flat="flat" @click="displayItem(item.slug)">Perfil</v-btn>
                            </v-card-actions-->
                            
                        </v-card-text>
                    
                    </v-card>
                </v-flex>
                
            

                
            
        </v-layout>
        <v-dialog v-model="dialogNewUsers" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Nova Mensagem</v-card-title>
                <v-card-text>
                    <label class="v-label theme--light">Selecione o usuário:</label>
                    <v-flex xs12 sm12 md12>
                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                            <v-select
                                :items="itemsUsuarios"
                                item-value="slug"
                                item-text="nome"
                                return-object
                                v-model="usuario"
                            ></v-select>
                        </v-card-text>
                    </v-flex><br />
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogNewUsers = false">Cancelar</v-btn>
                <v-btn color="green darken-1" flat @click="novaConversa">Iniciar conversa</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Tem certeza que deseja deletar a conversa?</v-card-title>
                <v-card-text>
                    
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">Não</v-btn>
                <v-btn color="green darken-1" flat @click="deletarItemConfirm">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Conversa deletada com sucesso!</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import db from './firebaseInit';
import firebase from 'firebase';

import { userProperties, usersData } from '@/global.js';

import lodash from 'lodash'
import VueLodash from 'vue-lodash'


export default {
    name: 'Mensagens-Listagem',
    data () {
        return {
            slug : '',
            perfil: userProperties.perfil,
            dialogDeleteConfirm: false,
            dialogNewUsers: false,
            dialog: false,
            loading: false,
            modalMessage: 'Conversa excluída com sucesso!',
            items: [],
            usuario: {
                // slug: 1,
                // nome: 'Alice'
            },
            itemsMensagens: [
                // {
                //         slug: 0,
                //         nome: 'Laura'
                // },
                // {
                //         alunoSlug: 1,
                //         alunoName: 'Alice'
                // }
            ],
            itemsUsuarios: [
                // {
                //         slug: 0,
                //         nome: 'Laura'
                // },
                // {
                //         alunoSlug: 1,
                //         alunoName: 'Alice'
                // }
            ]
        }
    },
    methods: {
        carregaDados() {

            this.items = []
            this.loading = true
            let obj = []
            this.itemsMensagens = []

            // Ordenar exibicao - Ordenacao alfabetica
            function compare(a,b) {
                if (a.nome < b.nome)
                    return -1;
                if (a.nome > b.nome)
                    return 1;
                return 0;
            }

            // ordernar exibicao - numerica
            function ordenarPorTimestamp(a, b){
                //return a.dataNumero - b.dataNumero; // crescente
                return b.customtimestamp - a.customtimestamp; // decrescente
            }

            db.collection('mensagens_'+userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    alert("Você ainda não possui mensagens");
                    this.loading = false
                }
                else{
                    var todosItens = [];
                    var groupsOfResult = [];
                    querySnapshot.forEach(doc => {
                        
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());                    
                        let customObj = doc.data()
                        // só exibe se o slug do usuário logado conter na junção dos 2 slugs 
                        if(customObj.AB.indexOf(userProperties.slug) >= 0){

                            var outraPessoa = "";
                            
                            // para procurar slug da outra pessoa para usar para redirecionamento e exibir a foto
                            outraPessoa = customObj.AB.replace(userProperties.slug, '');
                            
                            // Busca nome pelo Slug
                            var nomeChat = "";
                            var extensao = "";

                            usersData.usuarios.forEach((item, index) => {
                                if(item.slug == outraPessoa){
                                    nomeChat = item.nome;
                                    extensao = item.extensao;
                                }
                            });

                            // recupera imagem do firebase storage
                            var storageRef = firebase.storage().ref();
                            var tangRef = storageRef.child('profile/'+outraPessoa+'.'+extensao);

                            // First we sign in the user anonymously
                            //firebase.auth().signInAnonymously().then((result) => {
                            // Once the sign in completed, we get the download URL of the image
                            tangRef.getDownloadURL().then(urlImgFB =>                             {
                                // Once we have the download URL, we set it to our img element
                                this.urlImg = urlImgFB;
                                this.itemsMensagens.push({"AB": customObj.AB, "slug": customObj.slug, "extensao": extensao, "customtimestamp": customObj.customtimestamp, "mensagem": customObj.mensagem, "nomeChat":nomeChat, "slugOutraPessoa": outraPessoa, 'imagem':urlImgFB});

                                // Ordenacao numerica
                                this.itemsMensagens.sort(ordenarPorTimestamp)

                                // Remove itens repetidos do array com lodash - Remove pela propriedade repetidade
                                groupsOfResult = _.uniqBy(this.itemsMensagens, 'AB');
                                this.itemsMensagens = groupsOfResult;

                                }).catch(function(error) {
                                    // If anything goes wrong while getting the download URL, log the error,
                                    console.error(error);
                            });

                            // Ordenacao numerica
                            this.itemsMensagens.sort(ordenarPorTimestamp)                            
                        } 
                        
                        // Ordenacao numerica
                        this.itemsMensagens.sort(ordenarPorTimestamp)

                        this.slug = customObj.slug;                    
                    });
                    setTimeout(() => { this.loading = false }, 2000);
                }
                
                
            });

            db.collection("usuarios")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach(doc => {
                    
                    // doc.data() is never undefined for query doc snapshots
                    //console.log(doc.id, " => ", doc.data());                    
                    let customObj = doc.data()
                    // recupera imagem do firebase storage
                    var storageRef = firebase.storage().ref();
                    var tangRef = storageRef.child('profile/'+customObj.slug+'.'+customObj.extensao);
                    // First we sign in the user anonymously
                    //firebase.auth().signInAnonymously().then((result) => {
                    // Once the sign in completed, we get the download URL of the image
                    tangRef.getDownloadURL().then(urlImgFB =>                             {
                        // Once we have the download URL, we set it to our img element
                        this.urlImg = urlImgFB;
                        if(customObj.perfil != 7){
                            this.itemsUsuarios.push({"nome": customObj.nome, "email": customObj.email, "slug": customObj.slug, "imagem": urlImgFB, "perfil": customObj.perfil});
                        }
                        this.slug = customObj.slug;
                            // ordenar exibicao - Ordencacao alfabetica
                            this.itemsUsuarios.sort(compare);
                        }).catch(function(error) {
                            // If anything goes wrong while getting the download URL, log the error,
                            console.error(error);
                        });
                        // ordenar exibicao - Ordenacao alfabetica
                        this.itemsUsuarios.sort(compare);
                    
                });
            });
            var objNaoLidas = [];
            // Popula o numero de quantidade de notificações
            db.collection('notificacoes').where("destinatario", "==", userProperties.slug)
                .get()
                .then((querySnapshot) => {

                    // pega os slugs da notificacoes para marcar conversa como não lida
                    querySnapshot.forEach(doc => {
                    
                        //console.log(doc.id, " => ", doc.data());                    
                        let customObj = doc.data();
                        console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX")
                        console.log(customObj)
                        objNaoLidas.push(customObj.enviadoPor)
                        console.log(customObj.enviadoPor);
                        
                    
                    });

                    // set cookie
                    $.cookie("qtdNotificacoes", querySnapshot.size, { expires: 60 });


                    console.log("ZZZZZZZZZZZZZZZZZZZZ")
                    console.log(objNaoLidas)

                    setTimeout(function(){ 
                        objNaoLidas.forEach((item, index) => {
                            console.log(item);
                            $( "div[data-slug='"+item+"']" ).parent().addClass("nao-lida");
                        });
                
                    }, 1000);

                    
                    
                    
                });

        },
        novaConversa(){
            this.$router.push(`/chat?slug=`+this.usuario.slug)
        },
        goToMessage(slugOutraPessoa){
            this.$router.push(`/chat?slug=`+slugOutraPessoa)
        },
        deletarItem(slug){
            this.slug = slug;
            this.dialogDeleteConfirm = true;
        },
        deletarItemConfirm(){
            var slug = this.slug;
            this.loading = true
            db.collection('mensagens_'+userProperties.escolaID).where("slug", "==", slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    doc.ref.delete().then(() => {
                    this.dialog = true
                    console.log("Document successfully deleted!");
                    }).catch(function(error) {
                    console.error("Error removing document: ", error);
                    });
                });
                this.loading = false
                this.dialogDeleteConfirm = false;
                this.carregaDados();
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
                this.loading = false;
                this.dialogDeleteConfirm = false;
                alert("Error while trying to delete, please try again.");
            });
        },
        closeModal() {
            this.dialog = false      
            this.$router.push(`/`)
            this.$forceUpdate()
            Vue.delete(state.fixture, i)
        }
    },
    created() {

        this.carregaDados();
    }
};



</script>

<style scoped>
    .loading{
        position: fixed;
        top:20%;
        left:43%;
        z-index: 2;
    }

    .deletar{
        position: absolute;
        min-width: auto;
        height: auto;
        padding: 1px 6px !important;
        right: 0;
        top: 0;
    }

    .release{
        background-color:beige;
        position:absolute;
        right: 12px;
    }

    .editar{
        background-color:beige;
        position:absolute;
        right: 112px;
    }

    .imagem{
        width: 80px;
        height: 80px;
        margin-right: 12px;
        border:beige solid 1px;
        border-radius: 50%;
        background-position: center top;
        background-size: 100% auto;
        position: relative;
        top: -8px;
        margin-left: -10px;
    }

    .img{
        width: 120px;
        height: 120px;
        margin-right: 12px;
        border:beige solid 1px;
        border-radius: 50%;
        background-position: center top;
        background-size: 100% auto;
        position: relative;
        top:-6px;
        margin-left:12px;
        border: solid 4px #fff;
        margin: 30px auto auto auto;
    }

    .instagram{
        position: absolute;
        left: 15px;
    }

    .nao-lida{
        background: #e5d3f2;
    }
</style>
